// extracted by mini-css-extract-plugin
export default {"header":"theme_header__GK+kK","customStyles":"theme_customStyles__4xvFw"};